import { createSlice} from "@reduxjs/toolkit";

interface ServerError {
    title: string | null;
    message: string | null;
    raw?: unknown;
}
export type ErrorState = ServerError;
const initialState: ErrorState = {} as ServerError;
export const errorSlice = createSlice({
    name: 'serverError',
    initialState,
    reducers: {
    setServerError: (state: ErrorState, action ) => action.payload,
        clearServerError: () => {},
},
});
export const { setServerError, clearServerError } = errorSlice.actions;
export default errorSlice.reducer;
export type { ServerError };
